import React from 'react';
import PropTypes from 'prop-types';

import TeamMatchupImage from '@mlb/react-patterns/components/TeamMatchupImage/teamMatchupImage';

const srcsetWidth = {
    '372w': 372,
    '640w': 640,
    '750w': 750,
    '1024w': 1024,
    '1536w': 1536,
    '1920w': 1920,
    '2208w': 2208,
    '2608w': 2608,
};

const ImgFallback = (props) => {

    const {
        data,
        onImgLoaded,
    } = props;

    return (
        <TeamMatchupImage
            handlers={{
                onLoad: onImgLoaded,
                onError: onImgLoaded,
            }}
            awayTeamId={data?.away?.id}
            homeTeamId={data?.home?.id}
            ratio={'16:9'}
            srcWidth={750}
            srcsetWidth={srcsetWidth}
        />
    );

};

ImgFallback.propTypes = {
    onImgLoaded: PropTypes.func.isRequired,
    data: PropTypes.object,
};

ImgFallback.defaultProps = {
    data: {},
};

export default ImgFallback;
